import Box from "./Box";
import HeadingSmall from "./HeadingSmall";
import LargeHeadingImageSection from "./LargeHeadingImageSection";
import PropTypes from "prop-types";
import React from "react";
import RichTextLarge from "./RichTextLarge";
import TwoColBox from "./TwoColBox";
import YouTubePlayer from "./YouTubePlayer";

function BrandPageSectionTwo({
  imageDesktop,
  imageMobile,
  youtubeId,
  heading,
  text,
}) {
  return (
    <LargeHeadingImageSection
      bg="yellow"
      image={imageDesktop}
      imageAlt={imageDesktop.title}
      mobImage={imageMobile}
      mobImageAlt={imageMobile.title}
    >
      <Box pb={[20, null, 150, null]}>
        <TwoColBox
          col1={
            <Box position={[null, null, "sticky", null]} top={160}>
              <HeadingSmall>{heading}</HeadingSmall>
              {youtubeId && (
                <Box mt={[30, null, 40, null]}>
                  <YouTubePlayer videoId={youtubeId} />
                </Box>
              )}
            </Box>
          }
          col2={<RichTextLarge>{text}</RichTextLarge>}
        />
      </Box>
    </LargeHeadingImageSection>
  );
}

export default BrandPageSectionTwo;

BrandPageSectionTwo.propTypes = {
  imageDesktop: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  imageMobile: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};
